import { Currency } from '../../locale';

/**
 * Minimum order values in smallest currency unit (pence/cents).
 * Orders below these thresholds cost us money
 */
export const MIN_ORDER_VALUES: Record<Currency, number> = {
  AUD: 550,
  CAD: 500,
  EUR: 350,
  GBP: 300,
  USD: 400,
} as const;
